/** @jsx jsx */

import { jsx } from '@emotion/core';
import { Colors, Grid, Icon, Text } from '@zapier/design-system';

import {
  TABS as SIDEBAR_RIGHT_TABS,
  useSidebarRight,
} from 'app/developer-v3/components/SidebarRight';

import LinkWithArrow from 'app/developer-v3/components/LinkWithArrow';
import Styles from '../CTA.styles';

function Start() {
  const { update: updateSidebarRight } = useSidebarRight();

  return (
    <div css={Styles.root(Colors.Blue1)}>
      <Grid columns="24px auto" gap={20}>
        <Icon color="Blue3" name="miscUptime" size={24} />
        <div>
          <Text fontWeight={600} tag="h2" type="Body4">
            Welcome to the platform!
          </Text>
          <Text margin="10px 0px 0px" tag="p">
            Your project isn’t ready for external users yet. Start by testing
            your app to make sure everything is working, and then migrate your
            users and their Zaps in the{' '}
            <LinkWithArrow
              onClick={() =>
                updateSidebarRight({ tabActive: SIDEBAR_RIGHT_TABS.CONVERSION })
              }
            >
              side panel
            </LinkWithArrow>
          </Text>
        </div>
      </Grid>
    </div>
  );
}

export default Start;
